/*
 * nav/sagas
 *
 * Actions may be watched, but sagas should only ever call actionCreators,
 * and should not dispatch actions directly.
 */

import { call, put, takeLatest } from "redux-saga/effects";

import api from "../../api";
import { nav } from "../nav/actions";
import fetchInitialData from "../shared/sagas";
import { base } from "./actions";
import { CHECK_AUTH, CHECK_CRBS_CONFIGURED_START } from "./constants";

/**
 * If a user is already authenticated (has user set in localstorage),
 * return loginSuccess and fetchInitialData.
 */
export function* checkAuthSaga() {
  try {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      yield put(nav.loginSuccess(user));
      yield call(fetchInitialData);
    }
  } catch (error) {
    yield put(base.checkAuthFailed(error));
  }
}

export function* checkCrbsConfiguredSaga() {
  try {
    const response = yield call(api.Status.get);
    yield put(base.checkCrbsConfiguredSuccess(response));
  } catch (error) {
    yield put(base.checkCrbsConfiguredFailed(error));
  }
}

export function* watchCheckCrbsConfigured() {
  yield takeLatest(CHECK_CRBS_CONFIGURED_START, checkCrbsConfiguredSaga);
}

export function* watchCheckAuth() {
  yield takeLatest(CHECK_AUTH, checkAuthSaga);
}
